import React from 'react';

interface IfConditionProps {
    condition: boolean;
    children: React.ReactNode;
}

const IfCondition: React.FC<IfConditionProps> = (props) => {
    const { condition, children } = props;

    if (!condition) return null;

    return <>{children}</>;
};

export default IfCondition;
